import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url() {
    return buildApiUrl(ADMIN_ENDPOINTS.SETTINGS_BY_KEY || '/settings/byKey', {
      queryParams: {
        key: 'fees',
        service: 'rapidoo',
      },
    })
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Failed to fetch settings',
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Ok',
      data: raw.data.data || raw.data || {},
    }
  },
}
